import React from 'react';

const You = ({ social ,coach}) => {
    return (
        <div className={`${social ? '' : 'mx-1 hidden sm:block'}`}>
            <h2 className='bg-head text-center text-lg rounded-sm p-2 text-white cursor-pointer'>Youtube</h2>

            <div className=' grid grid-rows-2 p-2 gap-2'>
               {
                !coach ? <>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/c10qHfRrXPw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/la5lV3QDDq0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </>
                :
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/kxU-M6Xr88o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
               }

                <a className='text-center' target='_blank' href="https://www.youtube.com/channel/UCDhmFI0iZ_M7S5mD4xDRK-A?sub_confirmation=1"> <button className=' bg-cyan-700 rounded p-1 text-white w-2/3 mx-auto my-5'>Subscribe Now</button></a>

               <a target='_blank' href="https://www.youtube.com/channel/UCDhmFI0iZ_M7S5mD4xDRK-A"> <button className=' bg-cyan-600 rounded p-1 text-white w-full'>See more</button></a>
            </div>
        </div>
    );
};

export default You;